<template>
  <nav
    v-if="open"
    class="fixed bottom-0 left-0 right-0 top-0 z-10 bg-black/50 xl:static xl:bg-transparent"
  >
    <div class="fixed right-0 top-0 z-10 flex w-[280px] items-center justify-between p-4 xl:hidden">
      <HeaderUserMenu nav />
      <button
        @click="closeNav"
        aria-label="메뉴 닫기"
        class="flex h-9 w-9 items-center justify-center"
      >
        <X class="h-5 w-5" />
      </button>
    </div>

    <ul
      class="fixed bottom-0 right-0 top-0 w-[280px] gap-2 bg-white p-4 pt-16 xl:static xl:flex xl:w-auto xl:bg-transparent xl:p-0 xl:py-4 xl:pt-4 2xl:gap-4"
    >
      <li
        v-for="item in menuItems"
        :key="item.title"
        class="group relative text-sm transition xl:text-base xl:hover:text-primary"
      >
        <RouterLink :to="item.path" class="block p-4 py-4 xl:py-6">{{ item.title }}</RouterLink>

        <!-- has children -->
        <template v-if="item.children">
          <ul
            class="whitespace-nowrap rounded-md bg-gray-100 p-2 px-4 text-left xl:absolute xl:left-1/2 xl:top-full xl:hidden xl:-translate-x-1/2 xl:-translate-y-2 xl:gap-2 xl:rounded-xl xl:border xl:bg-white xl:text-center xl:shadow xl:group-hover:flex"
          >
            <li
              v-for="child in item.children"
              :key="child.title"
              class="text-black xl:hover:text-primary"
            >
              <RouterLink :to="child.path" class="block w-full p-1 text-xs xl:px-2 xl:text-sm">
                {{ child.title }}
              </RouterLink>
            </li>
          </ul>
        </template>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { X } from "lucide-vue-next";
import { useAuthStore } from '~/stores/authStore';
import * as _ from 'lodash';

const props = defineProps<{ open: boolean }>();
const emit = defineEmits<{ (e: "update:open", v: boolean): void }>();

const closeNav = () => emit("update:open", false);

const { me } = storeToRefs(useAuthStore());

const mentoringPath = computed(() => !_.isEmpty(me.value) ? "/mentoring/my" : "/mentoring" )
const lecturePath = computed(() => !_.isEmpty(me.value) ? "/mentoring/my" : "/lecture" )
const aiPath = computed(() => !_.isEmpty(me.value) ? "/ai-cording/my" : "/ai-cording" )
const mplayPath = computed(() => !_.isEmpty(me.value) ? "/m-playground/my" : "/m-playground" )
const menuItems = [
  { title: "Dream Up", path: "/about" },
  {
    title: "온라인 학습",
    path: "/lecture",
    children: [
      { title: "온라인 강의", path: "/lecture" },
      { title: "온라인 멘토링", path: mentoringPath },
      { title: "AI학습진단", path: "/ai" },
    ],
  },
  { title: "온라인 독서", path: "/reading" },
  {
    title: "AI코딩교육",
    path: aiPath,
    children: [
      { title: "이용안내", path: "/ai-cording" },
      { title: "나의 AI코딩교육", path: "/ai-cording/my" },
    ],
  },
  {
    title: "M-플레이그라운드",
    path: mplayPath,
    children: [
      { title: "이용안내", path: "/m-playground" },
      { title: "나의 M-플레이그라운드", path: "/m-playground/my" },
    ],
  },
  { title: "VR 스포츠", path: "/vr-sports" },
  {
    title: "소통공간",
    path: "/notice",
    children: [
      { title: "정보나눔터", path: "/notice" },
      { title: "이벤트", path: "/event" },
      { title: "학습지원센터", path: "/support" },
      { title: "강의 영상 보관함", path: "/video" },
    ],
  },
];
</script>
